import API from './api.js'

export default {
    async getParameterSets() {
        try {
            let response = await API.HTTPS.get('/sensors/parametersets')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async getSensors() {
        try {
            let response = await API.HTTPS.get('/sensors')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },
        
    async postSensor(data) {
        try {
            let response = await API.HTTPS.post('/sensors', data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async putSensor(data) {
        try {
            let response = await API.HTTPS.put('/sensors/' + data.id, data)

            if (response.status === 200) {
                return { code: 0, data: response.data }
            }
            else {
                return { code: 1, data: null }
            }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    },

    async deleteSensor(id) {
        try {
            let response = await API.HTTPS.delete('/sensors/' + id)

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}